import { checkIsAllowForPendingBills } from "helpers/utils";
import {
  ACTION_WORKFLOW_ISSUE_INVOICE,
  ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  ADJUST_ISSUE_INVOICE,
  ADJUST_ISSUE_INVOICE_FAIL,
  ADJUST_ISSUE_INVOICE_SUCCESS,
  ATTACK_FILE_INVOICE_UPLOAD,
  ATTACK_FILE_INVOICE_UPLOAD_FAIL,
  ATTACK_FILE_INVOICE_UPLOAD_RESET,
  ATTACK_FILE_INVOICE_UPLOAD_SUCCESS,
  BK_DATA_NEW,
  CANCEL_ISSUE_INVOICE,
  CANCEL_ISSUE_INVOICE_FAIL,
  CANCEL_ISSUE_INVOICE_SUCCESS,
  CLONE_ENVOICE,
  CLONE_ENVOICE_FAIL,
  CLONE_ENVOICE_SUCCESS,
  CREATE_ISSUE_INVOICE_ENTERPRISE,
  CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL,
  CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_FAIL,
  CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_SUCCESS,
  CREATE_ISSUE_INVOICE_ENTERPRISE_FAIL,
  CREATE_ISSUE_INVOICE_ENTERPRISE_SUCCESS,
  DELETE_ISSUE_INVOICE,
  DELETE_ISSUE_INVOICE_FAIL,
  DELETE_ISSUE_INVOICE_SUCCESS,
  DOWNLOAD_XML_ISSUE_INVOICE,
  DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
  DOWNLOAD_ZIP_INVOICE,
  DOWNLOAD_ZIP_INVOICE_FAIL,
  DOWNLOAD_ZIP_INVOICE_SUCCESS,
  EXPORT_INVOICE,
  EXPORT_INVOICE_FAIL,
  EXPORT_INVOICE_RESET,
  EXPORT_INVOICE_SUCCESS,
  EXPORT_INVOICE_TICKET,
  EXPORT_INVOICE_TICKET_FAIL,
  EXPORT_INVOICE_TICKET_RESET,
  EXPORT_INVOICE_TICKET_SUCCESS,
  EXPORT_INVOICE_WAREHOUSES,
  EXPORT_INVOICE_WAREHOUSES_AGENCY,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_RESET,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS,
  EXPORT_INVOICE_WAREHOUSES_FAIL,
  EXPORT_INVOICE_WAREHOUSES_RESET,
  EXPORT_INVOICE_WAREHOUSES_SUCCESS,
  GENERATE_NUMBER_INVOICE,
  GENERATE_NUMBER_INVOICE_FAIL,
  GENERATE_NUMBER_INVOICE_SUCCESS,
  GET_CURRENT_TIME,
  GET_CURRENT_TIME_FAIL,
  GET_CURRENT_TIME_SUCCESS,
  GET_DATA_LINK,
  GET_DATA_LINK_FAIL,
  GET_DATA_LINK_RESET,
  GET_DATA_LINK_SUCCESS,
  GET_ENTERPRISE_BY_TAX_CODE,
  GET_ENTERPRISE_BY_TAX_CODE_FAIL,
  GET_ENTERPRISE_BY_TAX_CODE_RESET,
  GET_ENTERPRISE_BY_TAX_CODE_SUCCESS,
  GET_INVOICE_MAX_DATE,
  GET_INVOICE_MAX_DATE_FAIL,
  GET_INVOICE_MAX_DATE_RESET,
  GET_INVOICE_MAX_DATE_SUCCESS,
  GET_INVOICE_MIN_DATE,
  GET_INVOICE_MIN_DATE_FAIL,
  GET_INVOICE_MIN_DATE_RESET,
  GET_INVOICE_MIN_DATE_SUCCESS,
  GET_INVOICE_REPORT_WORD,
  GET_INVOICE_REPORT_WORD_FAIL,
  GET_INVOICE_REPORT_WORD_SUCCESS,
  INVOICE_CAMPAIGN_DETAIL,
  INVOICE_CAMPAIGN_DETAIL_FAIL,
  INVOICE_CAMPAIGN_DETAIL_RESET,
  INVOICE_CAMPAIGN_DETAIL_SUCCESS,
  INVOICE_CAMPAIGN_LIST,
  INVOICE_CAMPAIGN_LIST_FAIL,
  INVOICE_CAMPAIGN_LIST_RESET,
  INVOICE_CAMPAIGN_LIST_SUCCESS,
  ISSUE_INVOICE_CREATE,
  ISSUE_INVOICE_CREATE_FAIL,
  ISSUE_INVOICE_CREATE_RESET,
  ISSUE_INVOICE_CREATE_SUCCESS,
  ISSUE_INVOICE_DETAIL,
  ISSUE_INVOICE_DETAIL_FAIL,
  ISSUE_INVOICE_DETAIL_RESET,
  ISSUE_INVOICE_DETAIL_SUCCESS,
  ISSUE_INVOICE_EDIT,
  ISSUE_INVOICE_EDIT_FAIL,
  ISSUE_INVOICE_EDIT_RESET,
  ISSUE_INVOICE_EDIT_SUCCESS,
  ISSUE_INVOICE_LIST,
  ISSUE_INVOICE_LIST_COLUMN,
  ISSUE_INVOICE_LIST_FAIL,
  ISSUE_INVOICE_LIST_RESET,
  ISSUE_INVOICE_LIST_SALE_HAVE_CODE_COLUMN,
  ISSUE_INVOICE_LIST_SALE_NONE_CODE_COLUMN,
  ISSUE_INVOICE_LIST_SUCCESS,
  ISSUE_INVOICE_LIST_VAT_NONE_CODE_COLUMN,
  LOAD_CONFIG_INVOICE_FIELD,
  LOAD_CONFIG_INVOICE_FIELD_FAIL,
  LOAD_CONFIG_INVOICE_FIELD_SUCCESS,
  PREVIEW_PDF_ISSUE_INVOICE,
  PREVIEW_PDF_ISSUE_INVOICE_FAIL,
  PREVIEW_PDF_ISSUE_INVOICE_SUCCESS,
  RELEASE_CAMPAIGNS_INVOICE,
  RELEASE_CAMPAIGNS_INVOICE_FAIL,
  RELEASE_CAMPAIGNS_INVOICE_RESET,
  RELEASE_CAMPAIGNS_INVOICE_SUCCESS,
  RELEASE_ISSUE_INVOICE,
  RELEASE_ISSUE_INVOICE_FAIL,
  RELEASE_ISSUE_INVOICE_SUCCESS,
  RELEASE_TAX_DEDUCT,
  RELEASE_TAX_DEDUCT_FAIL,
  RELEASE_TAX_DEDUCT_RESET,
  RELEASE_TAX_DEDUCT_SUCCESS,
  REMOVE_FILE_INVOICE,
  REMOVE_FILE_INVOICE_FAIL,
  REMOVE_FILE_INVOICE_RESET,
  REMOVE_FILE_INVOICE_SUCCESS,
  REPLACE_ISSUE_INVOICE,
  REPLACE_ISSUE_INVOICE_FAIL,
  REPLACE_ISSUE_INVOICE_SUCCESS,
  RESET_ACTION_WORKFLOW_ISSUE_INVOICE,
  RESET_ADJUST_ISSUE_INVOICE,
  RESET_BK_DATA_NEW,
  RESET_CANCEL_ISSUE_INVOICE,
  RESET_CLONE_ENVOICE,
  RESET_CREATE_ISSUE_INVOICE_ENTERPRISE,
  RESET_CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL,
  RESET_DELETE_ISSUE_INVOICE,
  RESET_DOWNLOAD_XML_ISSUE_INVOICE,
  RESET_DOWNLOAD_ZIP_INVOICE,
  RESET_GENERATE_NUMBER_INVOICE,
  RESET_GET_INVOICE_REPORT_WORD,
  RESET_PREVIEW_PDF_ISSUE_INVOICE,
  RESET_RELEASE_ISSUE_INVOICE,
  RESET_REPLACE_ISSUE_INVOICE,
  RESET_SEND_MAIL_INVOICE,
  RESET_TRANSFER_USB_INVOICE,
  SEND_MAIL_INVOICE,
  SEND_MAIL_INVOICE_FAIL,
  SEND_MAIL_INVOICE_SUCCESS,
  SET_COLUMN_VISIBLE_INVOICE_CAMPAIGN_LIST,
  TRANSFER_USB_INVOICE,
  TRANSFER_USB_INVOICE_FAIL,
  TRANSFER_USB_INVOICE_SUCCESS,
  UPLOAD_CAMPAIGNS_INVOICE,
  UPLOAD_CAMPAIGNS_INVOICE_FAIL,
  UPLOAD_CAMPAIGNS_INVOICE_RESET,
  UPLOAD_CAMPAIGNS_INVOICE_SUCCESS,
  UPLOAD_FILE_INVOICE,
  UPLOAD_FILE_INVOICE_FAIL,
  UPLOAD_FILE_INVOICE_RESET,
  UPLOAD_FILE_INVOICE_SUCCESS,
  UPLOAD_TAX_DEDUCT,
  UPLOAD_TAX_DEDUCT_FAIL,
  UPLOAD_TAX_DEDUCT_RESET,
  UPLOAD_TAX_DEDUCT_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  // List Issue Invoice
  list: {
    items: [],
    totalCount: 0,
    columnsVisibleInvoice: null,
    columnsVisibleVATNoneCode: null,
    columnsVisibleSaleHaveCode: null,
    columnsVisibleSaleNoneCode: null,
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
  },
  detailIssueInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  enterpriseByTaxCode: {
    loading: false,
    data: null,
    error: null,
  },
  loadingList: false,
  errorList: null,

  // Create Issue Invoice
  create: null,
  loadingCreate: false,
  errorCreate: null,
  // Edit Issue Invoice
  edit: null,
  loadingEdit: false,
  errorEdit: null,
  //
  successClone: false,
  configField: {
    error: null,
    loading: false,
    isFinish: false,
    businessUnitInfo: null,
    listCurrency: [],
    listVat: [],
    listPaymentMethod: [],
  },
  //
  releaseIssueInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // Xóa hóa đơn
  deleteInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // Hủy hóa đơn
  cancelInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // Download
  fileDownloadResponse: null,
  fileDownload: null,
  fileDownloadName: null,
  // send usb xml sign
  transferUSB: {
    data: null,
    error: null,
    loading: false,
  },
  //invoiceNumber
  invoiceNumber: {
    data: null,
    error: null,
    loading: false,
  },
  // Replace invoice
  replaceIssueInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // Adjust invoice
  adjustIssueInvoice: {
    loading: false,
    data: null,
    error: null,
  },
  // Send mail invoice
  sendMailInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  //
  previewPdfFile: {
    data: null,
    loading: false,
    error: null,
  },
  //
  uploadFile: null,
  loadingUploadFile: false,
  errorUploadFile: false,
  // SUBMIT/APPROVE/REJECT
  workflowInvoice: {
    loading: false,
    data: null,
    error: null,
    typeWorkflow: null,
  },
  // Tạo hóa đơn doanh nghiệp từ hóa đơn khách hàng lẻ
  createInvoiceEnterpriseData: {
    loading: false,
    data: null,
    error: null,
  },
  // Tạo hóa đơn điều chỉnh giảm 100%
  createInvoiceEnterpriseAdjustAllData: {
    loading: false,
    data: null,
    error: null,
  },
  // Upload biên bản hóa
  uploadFileInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Xóa biên bản hóa
  removeFileInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Export invoice
  exportInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Export invoice ticket
  exportInvoiceTicketData: {
    loading: false,
    data: null,
    error: null,
  },
  // export Invoice Warehouses Data
  exportInvoiceWarehousesData: {
    loading: false,
    data: null,
    error: null,
  },
  //export Invoice Warehouses Agency Data
  exportInvoiceWarehousesAgencyData: {
    loading: false,
    data: null,
    error: null,
  },
  //downloadZipInvoiceData
  downloadZipInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  //  Danh sách lô hóa đơn
  invoiceCampaignListData: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  // Upload lô hóa đơn
  uploadCampaignsInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Phát hành lô hóa đơn
  releaseCampaignsInvoiceData: {
    loading: false,
    data: null,
    error: null,
  },
  // Detail lô hóa đơn
  invoiceCampaignDetailData: {
    loading: false,
    data: null,
    error: null,
  },
  // Thông tin hóa đơn điều chỉnh thay thế child/parent
  linkTypeData: {
    loading: false,
    data: null,
    error: null,
  },
  // Thông tin của ngày lập hóa đơn đã phát hành gần nhất
  invoiceMaxDate: {
    loading: false,
    data: null,
    error: null,
  },
  // Thông tin của ngày lập hóa đơn lưu tạm xa nhất || Thông tin của ngày lập hóa đơn đã phát hành gần nhất
  invoiceMaxMinDate: {
    loading: false,
    data: null,
    error: null,
  },
  // Ngày hiện tại theo giờ hệ thống
  currentTime: {
    loading: false,
    data: null,
    error: null,
  },
  // Upload CTKT
  uploadTaxDeductData: {
    loading: false,
    data: null,
    error: null,
  },
  // Phát hành CTKT
  releaseTaxDeductData: {
    loading: false,
    data: null,
    error: null,
  },
};

const issueInvoice = (state = INIT_STATE, action) => {
  const curInvoiceCampaignListData = state.invoiceCampaignListData;
  switch (action.type) {
    // List Issue Invoice
    case ISSUE_INVOICE_LIST:
      return {
        ...state,
        loadingList: action.showLoading,
        errorList: null,
      };
    case ISSUE_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        errorList: null,
        loadingList: false,
        list: {
          ...state.list,
          items: action.payload.items?.map(i => {
            return {
              ...i,
              isAllowForPendingBills: checkIsAllowForPendingBills(i),
            };
          }),
          totalCount: action.payload._meta
            ? action.payload._meta.totalCount
            : action.payload.items.length,
        },
      };
    case ISSUE_INVOICE_LIST_FAIL:
      return { ...state, loadingList: false, errorList: action.payload };
    case ISSUE_INVOICE_LIST_RESET:
      return {
        ...state,
        loadingList: false,
        errorList: null,
        list: {
          ...state.list, // columnsVisible
          items: [],
          totalCount: 0,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
        },
      };
    //
    // Clone envoice
    case CLONE_ENVOICE:
      return {
        ...state,
        loadingList: true,
        errorList: null,
      };
    case CLONE_ENVOICE_SUCCESS:
      return {
        ...state,
        errorList: null,
        loadingList: false,
        successClone: true,
      };
    case CLONE_ENVOICE_FAIL:
      return {
        ...state,
        successClone: false,
        loadingList: false,
        errorList: action.payload,
      };
    case RESET_CLONE_ENVOICE:
      return {
        ...state,
        successClone: false,
        loadingList: false,
        errorList: action.payload,
      };

    // Detail Ủy quyền lập hóa đơn
    case ISSUE_INVOICE_DETAIL:
      return {
        ...state,
        detailIssueInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case ISSUE_INVOICE_DETAIL_SUCCESS:
      return {
        ...state,
        detailIssueInvoice: {
          loading: false,
          data: {
            ...action.data,
            isAllowForPendingBills: checkIsAllowForPendingBills(action.data),
          },
          error: null,
        },
      };

    case ISSUE_INVOICE_DETAIL_FAIL:
      return {
        ...state,
        detailIssueInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    case ISSUE_INVOICE_DETAIL_RESET:
      return {
        ...state,
        detailIssueInvoice: {
          loading: false,
          data: null,
          error: null,
        },
      };
    // GET_ENTERPRISE_BY_TAX_CODE
    case GET_ENTERPRISE_BY_TAX_CODE:
      return {
        ...state,
        enterpriseByTaxCode: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_ENTERPRISE_BY_TAX_CODE_SUCCESS:
      return {
        ...state,
        enterpriseByTaxCode: {
          loading: false,
          data: action.data,
          error: null,
        },
      };

    case GET_ENTERPRISE_BY_TAX_CODE_FAIL:
      return {
        ...state,
        enterpriseByTaxCode: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    case GET_ENTERPRISE_BY_TAX_CODE_RESET:
      return {
        ...state,
        enterpriseByTaxCode: {
          loading: false,
          data: null,
          error: null,
        },
      };
    //
    case ISSUE_INVOICE_LIST_COLUMN:
      const currentColumnsVisibleInvoice =
        state.list.columnsVisibleInvoice || {};
      currentColumnsVisibleInvoice[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: {
          ...state.list,
          columnsVisibleInvoice: currentColumnsVisibleInvoice,
        },
      };
    case ISSUE_INVOICE_LIST_VAT_NONE_CODE_COLUMN:
      const currentColumnsVATNoneCode =
        state.list.columnsVisibleVATNoneCode || {};
      currentColumnsVATNoneCode[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: {
          ...state.list,
          columnsVisibleVATNoneCode: currentColumnsVATNoneCode,
        },
      };
    case ISSUE_INVOICE_LIST_SALE_HAVE_CODE_COLUMN:
      const currentColumnsSaleHaveCode =
        state.list.columnsVisibleSaleHaveCode || {};
      currentColumnsSaleHaveCode[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: {
          ...state.list,
          columnsVisibleSaleHaveCode: currentColumnsSaleHaveCode,
        },
      };
    case ISSUE_INVOICE_LIST_SALE_NONE_CODE_COLUMN:
      const currentColumnsSaleNoneCode =
        state.list.columnsVisibleSaleNoneCode || {};
      currentColumnsSaleNoneCode[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: {
          ...state.list,
          columnsVisibleSaleNoneCode: currentColumnsSaleNoneCode,
        },
      };

    // Create Issue Invoice
    case ISSUE_INVOICE_CREATE:
      return {
        ...state,
        loadingCreate: true,
        errorCreate: null,
      };
    case ISSUE_INVOICE_CREATE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: { ...action.payload, success: true },
        type: action.type,
      };
    case ISSUE_INVOICE_CREATE_FAIL:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: action.payload,
        type: action.type,
      };
    case ISSUE_INVOICE_CREATE_RESET:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: null,
        create: null,
        type: action.type,
      };
    // Edit Issue Invoice
    case ISSUE_INVOICE_EDIT:
      return {
        ...state,
        loadingEdit: true,
        errorEdit: null,
      };
    case ISSUE_INVOICE_EDIT_SUCCESS:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: null,
        edit: { ...action.payload, success: true },
      };
    case ISSUE_INVOICE_EDIT_FAIL:
      return { ...state, loadingEdit: false, errorEdit: action.payload };
    case ISSUE_INVOICE_EDIT_RESET:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: null,
        edit: null,
      };
    //LOAD_CONFIG_INVOICE_FIELD
    case LOAD_CONFIG_INVOICE_FIELD:
      return {
        ...state,
        configField: {
          loading: true,
          isFinish: false,
          error: null,
          businessUnitInfo: null,
          listCurrency: [],
          listVat: [],
          listPaymentMethod: [],
        },
      };
    case LOAD_CONFIG_INVOICE_FIELD_SUCCESS:
      return {
        ...state,
        configField: {
          loading: false,
          isFinish: true,
          error: null,
          businessUnitInfo: action.businessUnitInfo,
          listCurrency: action.listCurrency,
          listVat: action.listVat,
          listPaymentMethod: action.listPaymentMethod,
        },
      };
    case LOAD_CONFIG_INVOICE_FIELD_FAIL:
      return {
        ...state,
        configField: {
          loading: false,
          isFinish: true,
          error: action.error,
          businessUnitInfo: null,
          listCurrency: [],
          listVat: [],
          listPaymentMethod: [],
        },
      };
    // Action Download
    case DOWNLOAD_XML_ISSUE_INVOICE:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
      };
    case DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS:
      return {
        ...state,
        type: action.type,
        fileDownloadResponse: action.fileDownloadResponse,
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
      };
    case DOWNLOAD_XML_ISSUE_INVOICE_FAIL:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadResponse: null,
        fileDownloadName: null,
        error: action.error,
      };
    case RESET_DOWNLOAD_XML_ISSUE_INVOICE:
      return {
        ...state,
        type: null,
        error: null,
        // fileDownloadResponse: null,
        // fileDownload: null,
        // fileDownloadName: null,
      };
    // Phát hành hóa đơn
    case RELEASE_ISSUE_INVOICE:
      return {
        ...state,
        releaseIssueInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case RELEASE_ISSUE_INVOICE_SUCCESS:
      return {
        ...state,
        releaseIssueInvoice: {
          loading: false,
          data: null,
          adjustAll: action.adjustAll,
          error: null,
        },
        type: action.type,
      };

    case RELEASE_ISSUE_INVOICE_FAIL:
      return {
        ...state,
        releaseIssueInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_RELEASE_ISSUE_INVOICE:
      return {
        ...state,
        releaseIssueInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Tạo đăng ký sử sụng
    case TRANSFER_USB_INVOICE:
      return {
        ...state,
        transferUSB: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case TRANSFER_USB_INVOICE_SUCCESS:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };

    case TRANSFER_USB_INVOICE_FAIL:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: action.error,
          loading: false,
        },
      };
    case RESET_TRANSFER_USB_INVOICE:
      return {
        ...state,
        type: action.type,
        transferUSB: {
          data: null,
          error: null,
          loading: false,
        },
      };
    // GENERATE_NUMBER_INVOICE
    case GENERATE_NUMBER_INVOICE:
      return {
        ...state,
        invoiceNumber: {
          data: null,
          error: null,
          loading: true,
        },
      };
    case GENERATE_NUMBER_INVOICE_SUCCESS:
      return {
        ...state,
        type: action.type,
        invoiceNumber: {
          data: action.data,
          error: null,
          loading: false,
        },
      };

    case GENERATE_NUMBER_INVOICE_FAIL:
      return {
        ...state,
        type: action.type,
        invoiceNumber: {
          data: null,
          error: action.error,
          loading: false,
        },
      };
    case RESET_GENERATE_NUMBER_INVOICE:
      return {
        ...state,
        type: action.type,
        invoiceNumber: {
          data: null,
          error: null,
          loading: false,
        },
      };
    // Thay thế hóa đơn
    case REPLACE_ISSUE_INVOICE:
      return {
        ...state,
        replaceIssueInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case REPLACE_ISSUE_INVOICE_SUCCESS:
      return {
        ...state,
        replaceIssueInvoice: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case REPLACE_ISSUE_INVOICE_FAIL:
      return {
        ...state,
        replaceIssueInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_REPLACE_ISSUE_INVOICE:
      return {
        ...state,
        replaceIssueInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Điều chỉnh hóa đơn
    case ADJUST_ISSUE_INVOICE:
      return {
        ...state,
        adjustIssueInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case ADJUST_ISSUE_INVOICE_SUCCESS:
      return {
        ...state,
        adjustIssueInvoice: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case ADJUST_ISSUE_INVOICE_FAIL:
      return {
        ...state,
        adjustIssueInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_ADJUST_ISSUE_INVOICE:
      return {
        ...state,
        adjustIssueInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // PREVIEW_PDF
    case PREVIEW_PDF_ISSUE_INVOICE:
      return {
        ...state,
        previewPdfFile: {
          data: null,
          loading: true,
          error: null,
        },
      };
    case PREVIEW_PDF_ISSUE_INVOICE_SUCCESS:
      return {
        ...state,
        previewPdfFile: {
          data: action.data,
          loading: false,
          error: null,
        },
      };
    case PREVIEW_PDF_ISSUE_INVOICE_FAIL:
      return {
        ...state,
        previewPdfFile: {
          data: null,
          loading: false,
          error: action.error,
        },
      };
    case RESET_PREVIEW_PDF_ISSUE_INVOICE:
      return {
        ...state,
        previewPdfFile: {
          data: null,
          loading: false,
          error: null,
        },
      };
    // Hủy hóa đơn
    case DELETE_ISSUE_INVOICE:
      return {
        ...state,
        deleteInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case DELETE_ISSUE_INVOICE_SUCCESS:
      return {
        ...state,
        deleteInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case DELETE_ISSUE_INVOICE_FAIL:
      return {
        ...state,
        deleteInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_DELETE_ISSUE_INVOICE:
      return {
        ...state,
        deleteInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Hủy hóa đơn
    case CANCEL_ISSUE_INVOICE:
      return {
        ...state,
        cancelInvoice: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CANCEL_ISSUE_INVOICE_SUCCESS:
      return {
        ...state,
        cancelInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case CANCEL_ISSUE_INVOICE_FAIL:
      return {
        ...state,
        cancelInvoice: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CANCEL_ISSUE_INVOICE:
      return {
        ...state,
        cancelInvoice: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Gửi mail hóa đơn
    case SEND_MAIL_INVOICE:
      return {
        ...state,
        sendMailInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case SEND_MAIL_INVOICE_SUCCESS:
      return {
        ...state,
        sendMailInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case SEND_MAIL_INVOICE_FAIL:
      return {
        ...state,
        sendMailInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_SEND_MAIL_INVOICE:
      return {
        ...state,
        sendMailInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // ATTACK_FILE_INVOICE_UPLOAD
    case ATTACK_FILE_INVOICE_UPLOAD:
      return {
        ...state,
        loadingUploadFile: true,
        errorUploadFile: null,
        type: action.type,
      };
    case ATTACK_FILE_INVOICE_UPLOAD_SUCCESS:
      return {
        ...state,
        loadingUploadFile: false,
        errorUploadFile: null,
        uploadFile: {
          id: action.payload.id,
          success: true,
        },
        type: action.type,
      };
    case ATTACK_FILE_INVOICE_UPLOAD_FAIL:
      return {
        ...state,
        loadingUploadFile: false,
        errorUploadFile: {
          error: action.payload.error,
          type: action.payload.type,
        },
        type: action.type,
      };
    case ATTACK_FILE_INVOICE_UPLOAD_RESET:
      return {
        ...state,
        loadingUploadFile: false,
        errorUploadFile: null,
        uploadFile: null,
        type: action.type,
      };

    // GET_INVOICE_REPORT_WORD
    case GET_INVOICE_REPORT_WORD:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadName: null,
      };
    case GET_INVOICE_REPORT_WORD_SUCCESS:
      return {
        ...state,
        type: action.type,
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
      };
    case GET_INVOICE_REPORT_WORD_FAIL:
      return {
        ...state,
        type: action.type,
        fileDownload: null,
        fileDownloadName: null,
        error: action.error,
      };
    case RESET_GET_INVOICE_REPORT_WORD:
      return {
        ...state,
        type: action.type,
        error: null,
        fileDownload: null,
        fileDownloadName: null,
      };
    // SUBMIT/APPROVE/REJECT
    case ACTION_WORKFLOW_ISSUE_INVOICE:
      return {
        ...state,
        workflowInvoice: {
          loading: true,
          data: null,
          error: null,
          typeWorkflow: null,
        },
      };
    case ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS:
      return {
        ...state,
        workflowInvoice: {
          loading: false,
          data: null,
          error: null,
          typeWorkflow: action.typeWorkflow,
        },
        type: action.type,
      };

    case ACTION_WORKFLOW_ISSUE_INVOICE_FAIL:
      return {
        ...state,
        workflowInvoice: {
          loading: false,
          data: null,
          error: action.error,
          typeWorkflow: action.typeWorkflow,
        },
        type: action.type,
      };
    case RESET_ACTION_WORKFLOW_ISSUE_INVOICE:
      return {
        ...state,
        workflowInvoice: {
          loading: false,
          data: null,
          error: null,
          typeWorkflow: null,
        },
        type: action.type,
      };
    // Tạo hóa đơn doanh nghiệp từ hóa đơn khách hàng lẻ
    case CREATE_ISSUE_INVOICE_ENTERPRISE:
      return {
        ...state,
        createInvoiceEnterpriseData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_ISSUE_INVOICE_ENTERPRISE_SUCCESS:
      return {
        ...state,
        createInvoiceEnterpriseData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_ISSUE_INVOICE_ENTERPRISE_FAIL:
      return {
        ...state,
        createInvoiceEnterpriseData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_ISSUE_INVOICE_ENTERPRISE:
      return {
        ...state,
        createInvoiceEnterpriseData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Tạo hóa đơn điều chỉnh giảm 100%
    case CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL:
      return {
        ...state,
        createInvoiceEnterpriseAdjustAllData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_SUCCESS:
      return {
        ...state,
        createInvoiceEnterpriseAdjustAllData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_FAIL:
      return {
        ...state,
        createInvoiceEnterpriseAdjustAllData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL:
      return {
        ...state,
        createInvoiceEnterpriseAdjustAllData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Upload biên bản đính kèm cho hóa đơn
    case UPLOAD_FILE_INVOICE:
      return {
        ...state,
        uploadFileInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case UPLOAD_FILE_INVOICE_SUCCESS:
      return {
        ...state,
        uploadFileInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case UPLOAD_FILE_INVOICE_FAIL:
      return {
        ...state,
        uploadFileInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case UPLOAD_FILE_INVOICE_RESET:
      return {
        ...state,
        uploadFileInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Xóa biên bản đính kèm cho hóa đơn
    case REMOVE_FILE_INVOICE:
      return {
        ...state,
        removeFileInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case REMOVE_FILE_INVOICE_SUCCESS:
      return {
        ...state,
        removeFileInvoiceData: {
          loading: false,
          data: action.id,
          error: null,
        },
        type: action.type,
      };

    case REMOVE_FILE_INVOICE_FAIL:
      return {
        ...state,
        removeFileInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case REMOVE_FILE_INVOICE_RESET:
      return {
        ...state,
        removeFileInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Xuất danh sách hóa đơn
    case EXPORT_INVOICE:
      return {
        ...state,
        exportInvoiceData: {
          loading: true,
          data: null,
          error: null,
          reportId: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case EXPORT_INVOICE_SUCCESS:
      return {
        ...state,
        exportInvoiceData: {
          loading: false,
          data: null,
          error: null,
          reportId: action.reportId,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case EXPORT_INVOICE_FAIL:
      return {
        ...state,
        exportInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
          reportId: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case EXPORT_INVOICE_RESET:
      return {
        ...state,
        exportInvoiceData: {
          loading: false,
          data: null,
          error: null,
          reportId: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    // Xuất danh sách tem phiếu
    case EXPORT_INVOICE_TICKET:
      return {
        ...state,
        exportInvoiceTicketData: {
          loading: true,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case EXPORT_INVOICE_TICKET_SUCCESS:
      return {
        ...state,
        exportInvoiceTicketData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case EXPORT_INVOICE_TICKET_FAIL:
      return {
        ...state,
        exportInvoiceTicketData: {
          loading: false,
          data: null,
          error: action.error,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case EXPORT_INVOICE_TICKET_RESET:
      return {
        ...state,
        exportInvoiceTicketData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    // Xuất phiếu xuất kho kiêm vận chuyển nội bộ
    case EXPORT_INVOICE_WAREHOUSES:
      return {
        ...state,
        exportInvoiceWarehousesData: {
          loading: true,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case EXPORT_INVOICE_WAREHOUSES_SUCCESS:
      return {
        ...state,
        exportInvoiceWarehousesData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case EXPORT_INVOICE_WAREHOUSES_FAIL:
      return {
        ...state,
        exportInvoiceWarehousesData: {
          loading: false,
          data: null,
          error: action.error,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case EXPORT_INVOICE_WAREHOUSES_RESET:
      return {
        ...state,
        exportInvoiceWarehousesData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    // Xuất phiếu xuất kho kiêm vận chuyển nội bộ
    case EXPORT_INVOICE_WAREHOUSES_AGENCY:
      return {
        ...state,
        exportInvoiceWarehousesAgencyData: {
          loading: true,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS:
      return {
        ...state,
        exportInvoiceWarehousesAgencyData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL:
      return {
        ...state,
        exportInvoiceWarehousesAgencyData: {
          loading: false,
          data: null,
          error: action.error,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case EXPORT_INVOICE_WAREHOUSES_AGENCY_RESET:
      return {
        ...state,
        exportInvoiceWarehousesAgencyData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };

    // Danh sách lô hóa đơn
    case INVOICE_CAMPAIGN_LIST:
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
          loading: true,
          //   params: action.params,
        },
      };
    case INVOICE_CAMPAIGN_LIST_SUCCESS:
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case INVOICE_CAMPAIGN_LIST_FAIL:
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case INVOICE_CAMPAIGN_LIST_RESET:
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    case SET_COLUMN_VISIBLE_INVOICE_CAMPAIGN_LIST:
      curInvoiceCampaignListData.columnsVisible[action.field] = action.value;
      return {
        ...state,
        invoiceCampaignListData: {
          ...curInvoiceCampaignListData,
        },
      };

    // Upload lô hóa đơn
    case UPLOAD_CAMPAIGNS_INVOICE:
      return {
        ...state,
        uploadCampaignsInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case UPLOAD_CAMPAIGNS_INVOICE_SUCCESS:
      return {
        ...state,
        uploadCampaignsInvoiceData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case UPLOAD_CAMPAIGNS_INVOICE_FAIL:
      return {
        ...state,
        uploadCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case UPLOAD_CAMPAIGNS_INVOICE_RESET:
      return {
        ...state,
        uploadCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Phát hành lô hóa đơn
    case RELEASE_CAMPAIGNS_INVOICE:
      return {
        ...state,
        releaseCampaignsInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case RELEASE_CAMPAIGNS_INVOICE_SUCCESS:
      return {
        ...state,
        releaseCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case RELEASE_CAMPAIGNS_INVOICE_FAIL:
      return {
        ...state,
        releaseCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RELEASE_CAMPAIGNS_INVOICE_RESET:
      return {
        ...state,
        releaseCampaignsInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Detail lô hóa đơn
    case INVOICE_CAMPAIGN_DETAIL:
      return {
        ...state,
        invoiceCampaignDetailData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case INVOICE_CAMPAIGN_DETAIL_SUCCESS:
      return {
        ...state,
        invoiceCampaignDetailData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case INVOICE_CAMPAIGN_DETAIL_FAIL:
      return {
        ...state,
        invoiceCampaignDetailData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case INVOICE_CAMPAIGN_DETAIL_RESET:
      return {
        ...state,
        invoiceCampaignDetailData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Get thông tin child/parent của hóa đơn thay thế/ điều chỉnh
    case GET_DATA_LINK:
      return {
        ...state,
        linkTypeData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DATA_LINK_SUCCESS:
      let root = undefined;
      let child = undefined;
      if (action.isGetChild) {
        child = action.data;
      } else {
        root = action.data;
      }
      return {
        ...state,
        linkTypeData: {
          loading: false,
          data: {
            root,
            child,
          },
          error: null,
        },
        type: action.type,
      };

    case GET_DATA_LINK_FAIL:
      return {
        ...state,
        linkTypeData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case GET_DATA_LINK_RESET:
      return {
        ...state,
        linkTypeData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Get thông tin ngày lập hóa đơn đã phát hành gần nhất
    case GET_INVOICE_MAX_DATE:
      return {
        ...state,
        invoiceMaxDate: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INVOICE_MAX_DATE_SUCCESS:
      return {
        ...state,
        invoiceMaxDate: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case GET_INVOICE_MAX_DATE_FAIL:
      return {
        ...state,
        invoiceMaxDate: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case GET_INVOICE_MAX_DATE_RESET:
      return {
        ...state,
        invoiceMaxDate: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Get thông tin ngày lập hóa đơn lưu tạm xa nhất
    case GET_INVOICE_MIN_DATE:
      return {
        ...state,
        invoiceMaxMinDate: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INVOICE_MIN_DATE_SUCCESS:
      return {
        ...state,
        invoiceMaxMinDate: {
          loading: true,
          data: {
            max: action.data.maxDate,
            min: action.data.minDate,
          },
          error: null,
        },
        type: action.type,
      };

    case GET_INVOICE_MIN_DATE_FAIL:
      return {
        ...state,
        invoiceMaxMinDate: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case GET_INVOICE_MIN_DATE_RESET:
      return {
        ...state,
        invoiceMaxMinDate: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    // Xuất phiếu xuất kho kiêm vận chuyển nội bộ
    case DOWNLOAD_ZIP_INVOICE:
      return {
        ...state,
        downloadZipInvoiceData: {
          loading: true,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
      };
    case DOWNLOAD_ZIP_INVOICE_SUCCESS:
      return {
        ...state,
        downloadZipInvoiceData: {
          loading: false,
          data: action.dataResponse,
          error: null,
        },
        fileDownload: action.fileDownload,
        fileDownloadName: action.fileDownloadName,
        type: action.type,
      };

    case DOWNLOAD_ZIP_INVOICE_FAIL:
      return {
        ...state,
        downloadZipInvoiceData: {
          loading: false,
          data: null,
          error: action.error,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    case RESET_DOWNLOAD_ZIP_INVOICE:
      return {
        ...state,
        downloadZipInvoiceData: {
          loading: false,
          data: null,
          error: null,
        },
        fileDownload: null,
        fileDownloadName: null,
        type: action.type,
      };
    // Upload chứng từ
    case UPLOAD_TAX_DEDUCT:
      return {
        ...state,
        uploadTaxDeductData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case UPLOAD_TAX_DEDUCT_SUCCESS:
      return {
        ...state,
        uploadTaxDeductData: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case UPLOAD_TAX_DEDUCT_FAIL:
      return {
        ...state,
        uploadTaxDeductData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case UPLOAD_TAX_DEDUCT_RESET:
      return {
        ...state,
        uploadTaxDeductData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Phát hành CTKT
    case RELEASE_TAX_DEDUCT:
      return {
        ...state,
        releaseTaxDeductData: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case RELEASE_TAX_DEDUCT_SUCCESS:
      return {
        ...state,
        releaseTaxDeductData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };

    case RELEASE_TAX_DEDUCT_FAIL:
      return {
        ...state,
        releaseTaxDeductData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RELEASE_TAX_DEDUCT_RESET:
      return {
        ...state,
        releaseTaxDeductData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    case BK_DATA_NEW:
      return {
        ...state,
        bkDataNew: action.data,
      };
    case RESET_BK_DATA_NEW:
      return {
        ...state,
        bkDataNew: null,
      };
    // Lấy ngày hiện tại theo giờ hệ thống
    case GET_CURRENT_TIME:
      return {
        ...state,
        currentTime: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_CURRENT_TIME_SUCCESS:
      return {
        ...state,
        currentTime: {
          loading: true,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case GET_CURRENT_TIME_FAIL:
      return {
        ...state,
        currentTime: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    default:
      return state;
  }
};

export default issueInvoice;
